<template>
  <div class="course-selection">
    <!-- 角色加载中显示加载状态 -->
    <div v-if="roleLoading" class="role-loading-container" v-loading="true"
      element-loading-text="加载用户信息..." :element-loading-fullscreen="false">
    </div>
    <!-- 角色加载完成后根据角色显示不同界面 -->
    <div v-else>
    <div class="course-header">
        <!-- 管理员可以看到标签切换 -->
        <div class="tab-menu" v-if="userRole === 'admin'">
        <div class="tab-item"
            :class="{ 'active': activeTab === 'learning' }" @click="setActiveTab('learning')">
          我学的课
        </div>
          <div class="tab-item" :class="{ 'active': activeTab === 'teaching' }" @click="setActiveTab('teaching')">
          我教的课
        </div>
      </div>

        <!-- 学生可以看到标签切换 -->
        <div class="tab-menu" v-if="userRole === 'student'">
        <div class="tab-item"
            :class="{ 'active': activeTab === 'learning' }" @click="setActiveTab('learning')">
          我学的课
        </div>
          <div class="tab-item" @click="goToCourseSelection">
          选课
        </div>
      </div>

        <!-- 学生端显示当前标签页标题 -->
        <!-- <div class="tab-header" v-if="userRole === 'student'">
          <h2>{{ activeTab === 'learning' ? '我学的课' : '可选课程' }}</h2>
        </div> -->

        <!-- 教师端只显示"我教的课"标题 -->
        <div class="tab-header" v-if="userRole === 'teacher'">
          <h2>我教的课</h2>
        </div>

      <div class="search-box">
        <el-input placeholder="搜索" prefix-icon="el-icon-search" v-model="searchText"></el-input>
      </div>
    </div>

      <!-- 课程类别卡片区域 - 仅在"我教的课"标签页显示 -->
      <div class="category-section" v-if="(userRole === 'teacher' || (userRole === 'admin' && activeTab === 'teaching'))">
        <div class="category-header">
          <h3>课程类别</h3>
          <el-button v-if="userRole === 'admin'" type="success" size="small" icon="el-icon-plus" @click="showAddCategoryDialog">添加类别</el-button>
        </div>
        <div class="category-cards" v-loading="categoryLoading">
          <div
            v-for="category in courseCategories"
            :key="category.id"
            class="category-card"
            :class="{ 'selected': selectedCategoryId === category.id }"
            @click="selectCategory(category.id)">
            <div class="category-card-image">
              <img v-if="category.image" :src="getCategoryImageUrl(category.image)" @error="handleCategoryImageError($event, category)">
              <div v-else class="category-card-placeholder">
                <i class="el-icon-folder-opened"></i>
              </div>
              <!-- 管理员可以编辑/删除类别 -->
              <div v-if="userRole === 'admin'" class="category-card-actions">
                <el-button type="primary" size="mini" icon="el-icon-edit" circle @click.stop="showEditCategoryDialog(category)"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-delete" circle @click.stop="handleDeleteCategory(category)"></el-button>
              </div>
            </div>
            <div class="category-card-info">
              <h4 class="category-card-name">{{ category.name }}</h4>
              <p class="category-card-desc">{{ category.description || '暂无描述' }}</p>
            </div>
          </div>
          <div v-if="courseCategories.length === 0 && !categoryLoading" class="empty-category">
            <i class="el-icon-folder-add"></i>
            <p>暂无课程类别</p>
          </div>
        </div>
      </div>

      <!-- 按钮区域 -->
    <div class="action-bar" v-if="selectedCategoryId || userRole === 'student' || (userRole === 'admin' && activeTab === 'learning')">
        <!-- 教师角色显示添加课程按钮（需要选择类别后才能添加） -->
        <el-button v-if="userRole === 'teacher' && selectedCategoryId"
                  type="primary" icon="el-icon-plus" @click="addCourse">添加课程</el-button>

        <!-- 管理员在"我教的课"标签也可以添加课程 -->
        <el-button v-if="userRole === 'admin' && activeTab === 'teaching' && selectedCategoryId"
                  type="primary" icon="el-icon-plus" @click="addCourse">添加课程</el-button>

        <!-- 学生角色或管理员的"我学的课"标签显示清除按钮 -->
        <el-button v-if="(userRole === 'student' || (userRole === 'admin' && activeTab === 'learning')) && selectedCourses.length > 0"
                  type="danger" plain icon="el-icon-delete" @click="clearSelectedCourses">清除所有选课</el-button>
    </div>

    <!-- 添加/编辑课程类别弹窗 -->
    <el-dialog :title="editingCategory ? '编辑课程类别' : '添加课程类别'" :visible.sync="createCategoryVisible" width="500px">
      <el-form :model="categoryForm" label-width="80px">
        <el-form-item label="类别封面">
          <div class="category-upload-container">
            <el-upload
              class="category-uploader"
              action="#"
              :http-request="uploadCategoryImage"
              :show-file-list="false"
              :before-upload="beforeCategoryImageUpload">
              <img v-if="categoryImageUrl" :src="categoryImageUrl" class="category-preview">
              <i v-else class="el-icon-plus category-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip" v-if="categoryImageUrl">
              <el-button size="mini" type="danger" @click="removeCategoryImage">移除图片</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="类别名称" required>
          <el-input v-model="categoryForm.name" placeholder="请输入类别名称"></el-input>
        </el-form-item>
        <el-form-item label="类别代码">
          <el-input v-model="categoryForm.code" placeholder="如 AMC、KANGAROO、GESP（用于系统识别）"></el-input>
        </el-form-item>
        <el-form-item label="类别描述">
          <el-input type="textarea" v-model="categoryForm.description" placeholder="请输入类别描述"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="closeCategoryDialog">取消</el-button>
        <el-button type="primary" @click="submitCategoryForm">确定</el-button>
      </span>
    </el-dialog>

      <!-- 课程列表区域 -->
    <div class="course-list">
        <div v-if="(userRole === 'student' && ((activeTab === 'learning' && learningLoading) || (activeTab === 'available' && availableLoading))) ||
                   (userRole === 'teacher' && loading) ||
                   (userRole === 'admin' && ((activeTab === 'learning' && learningLoading) || (activeTab === 'teaching' && loading)))"
               class="loading-container" v-loading="true" element-loading-text="加载课程中..." :element-loading-fullscreen="false">
        </div>

        <div v-else-if="courses.length === 0" class="empty-tip">
        <div class="empty-icon">
          <i class="el-icon-s-grid"></i>
        </div>
          <div>{{ userRole === 'teacher' ? '暂无教授课程，请添加课程' :
                   (userRole === 'student' && activeTab === 'learning') ? '暂无已选课程' :
                   (userRole === 'student' && activeTab === 'available') ? '暂无课程可选' :
                   activeTab === 'learning' ? '暂无已选课程' : '暂无课程，请添加课程' }}</div>
      </div>

        <!-- 课程列表 -->
        <el-row :gutter="20" v-else class="course-grid">
          <el-col :xs="24" :sm="12" :md="6" :lg="6" v-for="(course, index) in filteredCourses" :key="index" class="course-col">
          <div class="course-card"
            @click="handleCourseCardClick(course)"
            :class="{
              'selected-course': isCourseSelected(course),
              'teaching-course': activeTab === 'teaching'
            }">
            <div class="course-image">
                <img :src="course.image" @error="handleImageError($event, course)">
              <div v-if="isCourseSelected(course)" class="selected-badge">
                <i class="el-icon-check"></i>
              </div>
              <!-- 添加编辑和删除按钮，仅在"我教的课"标签页显示 -->
              <div v-if="activeTab === 'teaching'" class="course-actions">
                <el-button type="primary" size="mini" icon="el-icon-edit" circle @click.stop="handleUpdateCourse(course)"></el-button>
                  <el-button type="danger" size="mini" icon="el-icon-delete" circle @click.stop="deleteTeachCourse(course)"></el-button>
              </div>
              <!-- 添加选课按钮，仅在"可选课程"标签页显示 -->
              <div v-if="activeTab === 'available'" class="course-actions">
                <el-button type="success" size="mini" icon="el-icon-plus" circle @click.stop="selectCourse(course)"></el-button>
              </div>
              <!-- 学生用户"我学的课"标签页只显示退课按钮 -->
              <div v-if="activeTab === 'learning' && userRole === 'student'" class="course-actions">
                <el-button type="danger" size="mini" icon="el-icon-close" circle @click.stop="dropCourse(course)" :loading="dropLoading" title="退课"></el-button>
              </div>
              <!-- 管理员查看"我学的课"时显示完整操作按钮 -->
              <div v-if="activeTab === 'learning' && userRole === 'admin'" class="course-actions">
                <el-button type="primary" size="mini" icon="el-icon-view" circle @click.stop="viewCourseDetail(course)" title="查看详情"></el-button>
                <el-button type="success" size="mini" icon="el-icon-edit-outline" circle @click.stop="enterCourseLearning(course)" title="进入学习"></el-button>
                <el-button type="warning" size="mini" icon="el-icon-document" circle @click.stop="viewCourseResources(course)" title="课程资源"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-close" circle @click.stop="dropCourse(course)" :loading="dropLoading" title="退课"></el-button>
              </div>
            </div>
            <div class="course-info">
              <h3 class="course-title">{{ course.course_name}}</h3>
              <div class="course-meta">{{ course.organization}}</div>
              <div class="course-details">
                  <span class="course-teacher">{{ course.teacher_name}}</span>
                <span v-if="course.studentCount" class="course-students">
                  <i class="el-icon-user"></i> {{ course.studentCount }} 人
                </span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 添加CreateCourse组件 -->
    <create-course
      :visible.sync="createCourseVisible"
      :course-to-edit="courseToEdit"
      :selected-category-id="selectedCategoryId"
      @course-saved="handleCourseSaved"
    />
    </div>
  </div>
</template>

<script>
import CreateCourse from './CreateCourse.vue'
import { getUserInfo, verifyCurrentPassword } from '@/api/user'
import { getRole, getTokenInfo } from '@/utils/jwtUtils'
import { getCourseList, studentSelectedCourse, deleteCourse, getAvailableCourses, selectCourse, getCourseCategories, getCoursesByCategoryId, addCourseCategory, updateCourseCategory, deleteCourseCategory, uploadCourseImage } from '@/api/course'
import { getClassById, joinByInviteCode } from '@/api/amcCourseClass'
import { amcUserByUsername } from '@/api/amcuser'
import { Encrypt } from '@/utils/Secret'
import axios from 'axios'

export default {
  name: 'SelectCourse',
  components: {
    CreateCourse
  },
  data() {
    return {
      searchText: '',
      activeTab: 'learning', // 默认激活"我学的课"标签
      selectedCourses: [], // 改为数组，存储多个选中的课程
      learningCourses: [], // 修改为空数组，将从API加载
      teachingCourses: [],
      availableCourses: [], // 可选课程列表
      defaultImage: require('@/assets/img/封面.png'),
      userRole: '',
      userId: '', // 添加userId字段存储用户ID
      currentUserRealName: '', // 当前登录用户真实姓名/用户名
      createCourseVisible: false,
      courseToEdit: null,
      loading: false,
      learningLoading: false, // 添加学生课程加载状态
      availableLoading: false, // 可选课程加载状态
      roleLoading: false, // 用户角色加载状态
      dropLoading: false, // 退课加载状态
      imageErrorCache: new Set(), // 缓存已处理过错误的图片URL，防止重复处理
      userAmcInfo: null, // 存储用户AMC信息
      // 课程类别相关
      courseCategories: [], // 课程类别列表
      selectedCategoryId: null, // 当前选中的类别ID
      categoryLoading: false, // 类别加载状态
      createCategoryVisible: false, // 创建/编辑类别弹窗
      editingCategory: null, // 正在编辑的类别
      categoryForm: { name: '', code: '', description: '', image: '' }, // 类别表单
      categoryImageUrl: '', // 类别图片预览URL
      categoryImageFile: null // 类别图片文件
    }
  },
  computed: {
    // 根据用户角色返回对应的课程列表
    courses() {
      // 根据用户角色显示相应课程
      if (this.userRole === 'teacher') {
        return this.teachingCourses
      } else if (this.userRole === 'student') {
        // 学生根据当前标签页显示不同课程
        return this.activeTab === 'learning' ? this.learningCourses : this.availableCourses
      } else if (this.userRole === 'admin') {
        // 管理员按当前选择的标签显示
        return this.activeTab === 'learning' ? this.learningCourses : this.teachingCourses
      }

      // 默认返回
      return this.activeTab === 'learning' ? this.learningCourses : this.teachingCourses
    },
    filteredCourses() {
      if (!this.searchText) return this.courses

      const searchLower = this.searchText.toLowerCase()
      return this.courses.filter(course => {
        const courseName = course.course_name || ''
        const teacherName = course.teacher_name || ''
        const schoolName = course.organization || ''

        return courseName.toLowerCase().includes(searchLower) ||
               teacherName.toLowerCase().includes(searchLower) ||
               schoolName.toLowerCase().includes(searchLower)
      })
    }
  },
  methods: {
    // 从后端获取用户角色
    async fetchUserRole() {
      this.roleLoading = true

      try {
        // 尝试从令牌中获取用户ID
        const userInfo = getTokenInfo()
        if (userInfo && userInfo.id) {
          this.userId = userInfo.id
        }
        // 记录当前用户姓名（优先 realName，其次 userName）
        if (userInfo && (userInfo.realName || userInfo.userName)) {
          this.currentUserRealName = (userInfo.realName || userInfo.userName || '').trim()
        }

        // 方法1：从API获取用户信息
        const response = await getUserInfo()
        if (response && (response.code === 20000 || response.code === 1) && response.data) {
          // 如果API返回了用户ID，更新它
          if (response.data.id) {
            this.userId = response.data.id
          }
          // 同步姓名
          if (response.data.realName || response.data.userName) {
            this.currentUserRealName = (response.data.realName || response.data.userName || '').trim()
          }

          // 从API返回的roles数组中获取角色
          if (response.data.roles) {
            const roles = response.data.roles
            if (roles.includes('student')) {
              this.userRole = 'student'
            } else if (roles.includes('teacher') || roles.includes('mteacher')) {
              this.userRole = 'teacher'
            } else if (roles.includes('admin')) {
              this.userRole = 'admin'
            } else if (roles.includes('parent')) {
              this.userRole = 'parent'
            }
          } else if (response.data.roleId) {
            // 从roleId设置角色
            const roleId = response.data.roleId
            if (roleId === 1) {
              this.userRole = 'student'
            } else if (roleId === 2 || roleId === 4) {
              this.userRole = 'teacher'
            } else if (roleId === 3) {
              this.userRole = 'admin'
            } else if (roleId === 5) {
              this.userRole = 'parent'
            }
          }
        } else {
          // 方法2：从JWT令牌中获取
          await this.getRoleFromJwtOrStorage()
        }
      } catch (error) {
        console.error('获取用户角色失败:', error)
        // 如果API请求失败，尝试从JWT或localStorage获取
        await this.getRoleFromJwtOrStorage()
      } finally {
        this.roleLoading = false

        // 如果仍然没有角色，设置默认角色
        if (!this.userRole) {
          console.warn('无法获取用户角色，设置默认角色为学生')
          this.userRole = 'student'
        }

        // 根据获取到的角色设置默认标签页
        this.setDefaultTabByRole()

        // 加载相应的课程数据
        this.loadInitialCourses()

        // 如果是家长角色，立即加载课程
        if (this.userRole === 'parent') {
          this.loadLearningCourses()
        }
      }
    },

    // 检查并处理AMC课程
    async checkAndHandleAmcCourse() {
      try {
        console.log('开始检查用户AMC信息...')

        if (!this.userId) {
          console.log('用户ID不存在，跳转到AMC级别选择页面')
          this.$message.info('请先选择AMC级别')
          this.$router.push('/amc-level-select')
          return
        }

        // 实时获取用户AMC信息
        const response = await getAmcInfoByUserId(this.userId)
        console.log('实时获取的用户AMC信息:', response.data)

        if (response.data && response.data.length > 0) {
          const amcData = response.data[0] // 取第一条记录
          console.log('用户AMC分数:', amcData.amcMark)

          // 更新本地存储的AMC信息
          this.userAmcInfo = amcData

          if (amcData.amcMark === 0) {
            // 如果amcMark为0，跳转到AMC级别选择页面
            console.log('用户AMC分数为0，跳转到AMC级别选择页面')
            this.$message.info('请先选择AMC级别')
            this.$router.push('/amc-level-select')
          } else {
            // 如果amcMark不为0，跳转到AMC课程主页面
            console.log('用户AMC分数不为0，跳转到AMC课程主页面')
            this.$router.push('/amc-course')
          }
        } else {
          // 如果用户没有AMC信息，跳转到级别选择页面
          console.log('用户暂无AMC信息，跳转到AMC级别选择页面')
          this.userAmcInfo = null
          this.$message.info('请先选择AMC级别')
          this.$router.push('/amc-level-select')
        }
      } catch (error) {
        console.error('检查用户AMC信息失败:', error)
        // 出错时也跳转到级别选择页面
        this.userAmcInfo = null
        this.$message.info('请先选择AMC级别')
        this.$router.push('/amc-level-select')
      }
    },

    // 加载用户AMC信息
    async loadUserAmcInfo() {
      try {
        if (!this.userId) {
          console.log('用户ID不存在，跳过AMC信息加载')
          return
        }

        const response = await getAmcInfoByUserId(this.userId)
        console.log('用户AMC信息:', response.data)

        // 如果用户已有AMC信息，可以根据需要显示相关信息
        if (response.data && response.data.length > 0) {
          const amcData = response.data[0] // 取第一条记录
          console.log('用户已有AMC学习记录，数量:', response.data.length)
          console.log('用户AMC分数:', amcData.amcMark)

          // 将AMC信息存储到组件数据中，供其他方法使用
          this.userAmcInfo = amcData
        } else {
          console.log('用户暂无AMC学习记录')
          this.userAmcInfo = null
        }
      } catch (error) {
        console.error('获取用户AMC信息失败:', error)
        // 不显示错误提示，因为这是可选的功能
        this.userAmcInfo = null
      }
    },

    // 从JWT或本地存储获取角色和用户ID
    async getRoleFromJwtOrStorage() {
      try {
        // 先尝试获取完整的用户信息以获取用户ID
        const userInfo = getTokenInfo()
        if (userInfo && userInfo.id) {
          this.userId = userInfo.id
        }

        // 然后获取角色ID
        const roleId = getRole()
        if (roleId === 1) {
          this.userRole = 'student'
        } else if (roleId === 2 || roleId === 4) {
          this.userRole = 'teacher'
        } else if (roleId === 3) {
          this.userRole = 'admin'
        } else if (roleId === 5) {
          this.userRole = 'parent'
        }
      } catch (jwtError) {
        console.error('从JWT获取角色失败:', jwtError)
        // 如果JWT解析失败，尝试从localStorage获取
        const role = localStorage.getItem('roles')
        if (role) {
          this.userRole = role
        }
      }
    },

    // 根据角色设置默认标签页
    setDefaultTabByRole() {
      if (this.userRole === 'teacher') {
        this.activeTab = 'teaching'
      } else if (this.userRole === 'student') {
        this.activeTab = 'learning'
      } else if (this.userRole === 'admin') {
        // 管理员默认显示教师界面
        this.activeTab = 'teaching'
      }
    },

    // 设置当前激活的标签
    setActiveTab(tab) {
      this.activeTab = tab

      // 当切换到"我教的课"标签页时，加载课程类别和课程数据
      if (tab === 'teaching') {
        this.loadCourseCategories()
      } else if (tab === 'learning') {
        // 当切换到"我学的课"标签页时，加载学生选课数据
        this.loadLearningCourses()
      } else if (tab === 'available') {
        // 当切换到"可选课程"标签页时，加载可选课程数据
        this.loadAvailableCourses()
      }
    },

    // 跳转到选课页面
    goToCourseSelection() {
      this.$router.push('/course/selection')
    },

    // 完成选课并跳转到我的课程界面
    finishSelection() {
      // 如果没有选择任何课程，提示用户先选课
      if (this.learningCourses.length === 0) {
        this.$message({
          type: 'warning',
          message: '您还没有任何课程，请先选择课程',
          duration: 2000
        })

        // 跳转到选课页面
        setTimeout(() => {
          this.$router.push('/course/selection')
        }, 1500)

        return
      }

      // 显示成功消息
      this.$message({
        type: 'success',
        message: '课程确认完成',
        duration: 1500
      })
    },

    loadCourses() {
      // 只在"我教的课"界面或教师角色情况下加载课程
      if (this.activeTab !== 'teaching' && this.userRole !== 'teacher') {
        console.log('不是"我教的课"界面或非教师角色，跳过加载课程')
        return
      }
      this.loading = true
      getCourseList()
        .then(response => {
          if (Array.isArray(response)) {
            // 更新教学课程列表
            // map() 遍历 courses 数组中的每个元素（即每个课程对象 course）
            // 对每个 course 执行箭头函数中的逻辑，并将结果收集到一个新数组中
            this.teachingCourses = response.map(course => {
              // 处理图片路径 - 借鉴用户头像的显示逻辑
              let imageUrl = this.getCourseImageUrl(course.image)
              return {
                id: course.id,
                teacher_name: course.teacher_name,
                course_name: course.course_name,
                organization: course.organization,
                term: course.term,
                profile: course.profile,
                target: course.target,
                studentCount: course.studentCount || 0,
                image: imageUrl,
                originalImage: course.image // 保存原始URL用于编辑
              }
            })
            // 教师登录时，仅显示与当前教师姓名一致的课程
            if (this.userRole === 'teacher' && this.currentUserRealName) {
              const teacherName = this.currentUserRealName
              this.teachingCourses = this.teachingCourses.filter(item => (item.teacher_name || '').trim() === teacherName)
            }
          } else {
            console.error('课程数据格式不正确:', response)
            this.$message.error('课程数据格式不正确')
          }
        })
        .catch(error => {
          console.error('加载课程出错:', error)
          this.$message.error('加载课程失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 加载课程类别列表
    loadCourseCategories() {
      this.categoryLoading = true
      getCourseCategories()
        .then(response => {
          if (response && response.code === 1 && response.data) {
            this.courseCategories = response.data
            // 如果有类别，默认选中第一个
            if (this.courseCategories.length > 0 && !this.selectedCategoryId) {
              this.selectedCategoryId = this.courseCategories[0].id
              // 加载该类别下的课程
              this.loadCoursesByCategory(this.selectedCategoryId)
            }
          }
        })
        .catch(error => {
          console.error('加载课程类别失败:', error)
          this.$message.error('加载课程类别失败')
        })
        .finally(() => {
          this.categoryLoading = false
        })
    },

    // 选择课程类别
    selectCategory(categoryId) {
      this.selectedCategoryId = categoryId
      this.loadCoursesByCategory(categoryId)
    },

    // 根据类别加载课程
    loadCoursesByCategory(categoryId) {
      this.loading = true
      getCoursesByCategoryId(categoryId)
        .then(response => {
          if (Array.isArray(response)) {
            this.teachingCourses = response.map(course => {
              let imageUrl = this.getCourseImageUrl(course.image)
              return {
                id: course.id,
                teacher_name: course.teacherName || course.teacher_name,
                course_name: course.courseName || course.course_name,
                organization: course.organization,
                term: course.term,
                profile: course.profile,
                target: course.target,
                category_id: course.categoryId || course.category_id,
                repo_id: course.repoId || course.repo_id,
                code_repo_id: course.codeRepoId || course.code_repo_id,
                studentCount: course.studentCount || 0,
                image: imageUrl,
                originalImage: course.image
              }
            })
            // 教师登录时，仅显示与当前教师姓名一致的课程
            if (this.userRole === 'teacher' && this.currentUserRealName) {
              const teacherName = this.currentUserRealName
              this.teachingCourses = this.teachingCourses.filter(item => (item.teacher_name || '').trim() === teacherName)
            }
          }
        })
        .catch(error => {
          console.error('加载课程失败:', error)
          this.$message.error('加载课程失败')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 显示添加类别弹窗
    showAddCategoryDialog() {
      this.editingCategory = null
      this.categoryForm = { name: '', code: '', description: '', image: '' }
      this.categoryImageUrl = ''
      this.categoryImageFile = null
      this.createCategoryVisible = true
    },

    // 显示编辑类别弹窗
    showEditCategoryDialog(category) {
      this.editingCategory = category
      this.categoryForm = {
        id: category.id,
        name: category.name,
        code: category.code || '',
        description: category.description || '',
        image: category.image || ''
      }
      this.categoryImageUrl = category.image ? this.getCategoryImageUrl(category.image) : ''
      this.categoryImageFile = null
      this.createCategoryVisible = true
    },

    // 关闭类别弹窗
    closeCategoryDialog() {
      this.createCategoryVisible = false
      this.editingCategory = null
      this.categoryForm = { name: '', code: '', description: '', image: '' }
      this.categoryImageUrl = ''
      this.categoryImageFile = null
    },

    // 上传类别图片前验证
    beforeCategoryImageUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!')
        return false
      }
      return true
    },

    // 上传类别图片
    uploadCategoryImage(options) {
      this.categoryImageFile = options.file
      this.categoryImageUrl = URL.createObjectURL(options.file)
      this.categoryForm.image = this.categoryImageUrl
    },

    // 移除类别图片
    removeCategoryImage() {
      this.categoryImageUrl = ''
      this.categoryImageFile = null
      this.categoryForm.image = ''
    },

    // 获取类别图片URL
    getCategoryImageUrl(imageUrl) {
      if (!imageUrl) return ''
      const { getCourseCoverUrl } = require('@/utils/minio')
      return getCourseCoverUrl(imageUrl) || imageUrl
    },

    // 处理类别图片加载错误
    handleCategoryImageError(event, category) {
      event.target.style.display = 'none'
    },

    // 提交类别表单（添加或编辑）
    async submitCategoryForm() {
      if (!this.categoryForm.name) {
        this.$message.warning('请输入类别名称')
        return
      }

      try {
        // 如果有新上传的图片，先上传图片
        if (this.categoryImageFile) {
          const formData = new FormData()
          formData.append('file', this.categoryImageFile)
          formData.append('bucketName', 'course-cover')
          const uploadRes = await uploadCourseImage(formData)
          if (uploadRes && uploadRes.code === 1 && uploadRes.data) {
            this.categoryForm.image = uploadRes.data
          }
        }

        const submitData = {
          name: this.categoryForm.name,
          code: this.categoryForm.code || '',
          description: this.categoryForm.description,
          image: this.categoryForm.image
        }

        let response
        if (this.editingCategory) {
          // 编辑模式
          submitData.id = this.editingCategory.id
          response = await updateCourseCategory(submitData)
        } else {
          // 添加模式
          response = await addCourseCategory(submitData)
        }

        if (response && response.code === 1) {
          this.$message.success(this.editingCategory ? '更新类别成功' : '添加类别成功')
          this.closeCategoryDialog()
          this.loadCourseCategories()
        } else {
          this.$message.error(response?.msg || (this.editingCategory ? '更新类别失败' : '添加类别失败'))
        }
      } catch (error) {
        console.error('提交类别失败:', error)
        this.$message.error('操作失败')
      }
    },

    // 删除类别
    handleDeleteCategory(category) {
      this.$confirm(
        `确定要删除类别"${category.name}"吗？\n\n此操作将同时删除该类别下的所有课程、题库、班级及学生注册记录，且不可恢复！`,
        '警告',
        {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        deleteCourseCategory(category.id)
          .then(response => {
            if (response && response.code === 1) {
              this.$message.success('删除成功')
              // 如果删除的是当前选中的类别，清空选中状态
              if (this.selectedCategoryId === category.id) {
                this.selectedCategoryId = null
                this.teachingCourses = []
              }
              this.loadCourseCategories()
            } else {
              this.$message.error(response?.msg || '删除失败')
            }
          })
          .catch(error => {
            console.error('删除类别失败:', error)
            this.$message.error('删除失败')
          })
      }).catch(() => {})
    },

    // 添加课程
    addCourse() {
      this.courseToEdit = null
      this.createCourseVisible = true
    },

    handleCourseSaved() {
      // 重新加载课程列表
      if (this.selectedCategoryId) {
        this.loadCoursesByCategory(this.selectedCategoryId)
      } else {
        // 如果没有选择类别，重新加载课程类别列表
        this.loadCourseCategories()
      }
      // 同时刷新教学课程列表
      if (this.userRole === 'teacher' || (this.userRole === 'admin' && this.activeTab === 'teaching')) {
        this.loadCourses()
      }
    },

    // 判断课程是否已被选中
    isCourseSelected(course) {
      return this.selectedCourses.some(item => item.id === course.id)
    },

    // 移除单个课程
    removeCourse(course) {
      const index = this.selectedCourses.findIndex(item => item.id === course.id)
      if (index !== -1) {
        this.selectedCourses.splice(index, 1)
        this.saveSelectedCourses()
        this.$message({
          type: 'success',
          message: `已移除课程: ${course.course_name}`
        })
      }
    },

    // 保存选中的课程到localStorage
    saveSelectedCourses() {
      localStorage.setItem('selectedCourses', JSON.stringify(this.selectedCourses))
    },

    // 清除所有选中的课程
    clearSelectedCourses() {
      this.$confirm('确定要清除所有选课吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        customClass: 'course-confirm-dialog'
      }).then(() => {
        this.selectedCourses = []
        localStorage.removeItem('selectedCourses')
        this.$message({
          type: 'success',
          message: '已清除所有选课'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },

    // 加载已选课程
    checkSelectedCourses() {
      // 从localStorage中获取选课信息（保留此功能，以便保持向后兼容）
      const selectedCoursesStr = localStorage.getItem('selectedCourses')
      if (selectedCoursesStr) {
        try {
          const courses = JSON.parse(selectedCoursesStr)
          this.selectedCourses = courses
          if (courses.length > 0) {
            this.$message({
              type: 'info',
              message: `您当前已选择 ${courses.length} 门课程`,
              duration: 3000
            })
          }
        } catch (e) {
          // 如果解析失败，清除无效数据
          localStorage.removeItem('selectedCourses')
          this.selectedCourses = []
        }
      }
    },

    // 获取课程封面URL - 统一处理course-cover bucket
    getCourseImageUrl(imageUrl) {
      const { getCourseCoverUrl } = require('@/utils/minio')
      const processedUrl = getCourseCoverUrl(imageUrl)
      return processedUrl || this.defaultImage
    },

    // 处理图片加载错误
    handleImageError(event, course) {
      const failedImageUrl = course.image

      // 如果这个图片URL已经处理过错误，直接设置为默认图片，避免重复处理
      if (this.imageErrorCache.has(failedImageUrl)) {
        event.target.src = this.defaultImage
        return
      }

      // 将失败的图片URL添加到缓存中
      this.imageErrorCache.add(failedImageUrl)

      // 设置为默认图片
      event.target.src = this.defaultImage

      // 记录错误日志
      console.warn(`课程封面加载失败，已使用默认图片: ${failedImageUrl}`)

      // 可选：更新课程对象中的image字段，避免后续重复尝试加载
      if (course && course.image === failedImageUrl) {
        course.image = this.defaultImage
      }
    },
    // 从后端加载学生已选课程
    loadLearningCourses() {
      // 只在"我学的课"界面或学生角色情况下加载课程
      if (this.activeTab !== 'learning' && this.userRole !== 'student' && this.userRole !== 'parent') {
        console.log('不是"我学的课"界面或非学生/家长角色，跳过加载课程')
        return
      }
      // 检查是否有userId
      if (!this.userId) {
        console.error('缺少用户ID，无法加载课程')
        this.$message.error('无法获取用户信息，请刷新页面重试')
        return
      }
      this.learningLoading = true
      if (this.userRole === 'parent') {
        // 家长角色：先获取绑定的学生ID
        axios.get('http://localhost:8080/api/connectuser/parent/' + this.userId, { withCredentials: true })
          .then(response => {
            response = response.data
            if (response.code === 1 && response.data && response.data.length > 0) {
              const studentId = response.data[0].studentId
              // 用学生ID加载课程
              return studentSelectedCourse(studentId)
            } else {
              throw new Error('未找到绑定的学生')
            }
          })
          .then(response => {
            if (response && response.code === 1 && response.data) {
              const courses = response.data
              // 处理每个课程的图片地址 - 借鉴用户头像的显示逻辑
              this.learningCourses = courses.map(course => {
                console.log('处理家长课程封面:', course.course_name, '原始image:', course.image)
                let imageUrl = this.getCourseImageUrl(course.image)
                console.log('处理后的image URL:', imageUrl)
                return {
                  ...course,
                  image: imageUrl,
                  // 确保课程ID字段正确映射
                  id: course.course_id || course.id
                }
              })
              console.log('家长课程数据加载完成:', this.learningCourses)
            } else {
              console.error('获取已选课程列表失败:', response.data)
              this.$message.error(response.data?.msg || '获取已选课程列表失败')
            }
          })
          .catch(error => {
            console.error('加载已选课程出错:', error)
            this.$message.error('加载已选课程失败，请稍后重试')
          })
          .finally(() => {
            this.learningLoading = false
          })
      } else {
        // 学生角色：直接加载课程
        console.log('开始加载学生课程，用户ID:', this.userId)
        studentSelectedCourse(this.userId)
          .then(response => {
            console.log('学生课程API响应:', response)
            if (response && response.code === 1 && response.data) {
              const courses = response.data
              console.log('原始课程数据:', courses)
              // 处理每个课程的图片地址 - 借鉴用户头像的显示逻辑
              this.learningCourses = courses.map(course => {
                console.log('处理已选课程封面:', course.course_name, '原始image:', course.image)
                let imageUrl = this.getCourseImageUrl(course.image)
                console.log('处理后的image URL:', imageUrl)
                const mappedCourse = {
                  ...course,
                  image: imageUrl,
                  originalImage: course.image, // 保存原始URL用于编辑
                  // 确保使用选课记录的主键ID用于退课操作
                  id: course.id, // 选课记录的主键ID
                  course_id: course.course_id // 课程ID
                }
                console.log('映射后的课程:', mappedCourse)
                return mappedCourse
              })
              console.log('学生课程数据加载完成:', this.learningCourses)
            } else {
              console.error('获取已选课程列表失败:', response)
              this.$message.error(response?.msg || '获取已选课程列表失败')
            }
          })
          .catch(error => {
            console.error('加载已选课程出错:', error)
            this.$message.error('加载已选课程失败，请稍后重试')
          })
          .finally(() => {
            this.learningLoading = false
          })
      }
    },

    // 加载可选课程列表
    loadAvailableCourses() {
      if (!this.userId) {
        console.error('缺少用户ID，无法加载可选课程')
        this.$message.error('无法获取用户信息，请刷新页面重试')
        return
      }

      this.availableLoading = true
      console.log('开始加载可选课程，用户ID:', this.userId)

      getAvailableCourses()
        .then(response => {
          console.log('可选课程API响应:', response)
          if (response && response.code === 1 && response.data) {
            const courses = response.data
            console.log('原始可选课程数据:', courses)
            // 处理每个课程的图片地址
            this.availableCourses = courses.map(course => {
              console.log('处理可选课程封面:', course.course_name, '原始image:', course.image)
              let imageUrl = this.getCourseImageUrl(course.image)
              console.log('处理后的image URL:', imageUrl)
              const mappedCourse = {
                ...course,
                image: imageUrl,
                originalImage: course.image, // 保存原始URL
                id: course.id
              }
              console.log('映射后的可选课程:', mappedCourse)
              return mappedCourse
            })
            console.log('可选课程数据加载完成:', this.availableCourses)
          } else {
            console.error('获取可选课程列表失败:', response)
            this.$message.error(response?.msg || '获取可选课程列表失败')
          }
        })
        .catch(error => {
          console.error('加载可选课程出错:', error)
          this.$message.error('加载可选课程失败，请稍后重试')
        })
        .finally(() => {
          this.availableLoading = false
        })
    },

    // 学生选课
    selectCourse(course) {
      if (!this.userId) {
        this.$message.error('无法获取用户信息，请重新登录')
        return
      }

      this.$confirm(`您确定要选择课程"${course.course_name}"吗？`, '确认选课', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        // 构造选课数据
        const courseData = {
          course_id: course.id,
          teacher_name: course.teacher_name,
          course_name: course.course_name,
          term: course.term,
          organization: course.organization
        }

        console.log('提交选课数据:', courseData)

        selectCourse(this.userId, courseData)
          .then(response => {
            console.log('选课API响应:', response)
            if (response && response.code === 1) {
              this.$message.success('选课成功！')
              // 选课成功后，刷新已选课程列表
              this.loadLearningCourses()
              // 从可选课程列表中移除已选课程
              this.availableCourses = this.availableCourses.filter(c => c.id !== course.id)
            } else {
              console.error('选课失败:', response)
              this.$message.error(response?.msg || '选课失败，请稍后重试')
            }
          })
          .catch(error => {
            console.error('选课出错:', error)
            this.$message.error('选课失败，请稍后重试')
          })
      }).catch(() => {
        this.$message.info('已取消选课')
      })
    },

    // 退选课程
    async dropCourse(course) {
      this.$confirm(`您确定要退选课程"${course.course_name}"吗？`, '确认退选', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async () => {
        this.dropLoading = true
        try {
          const courseId = course.id
          console.log('退课请求 - 课程对象:', course)
          console.log('退课请求 - 选课记录ID:', courseId)

          if (!courseId) {
            this.$message.error('选课记录ID不存在，无法退选')
            return
          }

          // 导入dropCourse API函数
          const { dropCourse } = await import('@/api/course')

          const response = await dropCourse(courseId)

          if (response && response.code === 1) {
            this.$message.success('退选成功！')
            // 退选成功后，刷新已选课程列表
            this.loadLearningCourses()
          } else {
            console.error('退选失败:', response)
            this.$message.error(response?.msg || '退选失败，请稍后重试')
          }
        } catch (error) {
          console.error('退选出错:', error)
          this.$message.error('退选失败，请稍后重试')
        } finally {
          this.dropLoading = false
        }
      }).catch(() => {
        this.$message.info('已取消退选')
      })
    },

    // 更新课程信息
    handleUpdateCourse(course) {
      // 确保course对象包含id字段
      if (!course.id) {
        console.error('课程对象缺少ID字段:', course)
        this.$message.error('无法编辑课程：缺少课程ID')
        return
      }

      // 设置courseToEdit，这样CreateCourse组件就能获取到课程数据
      // 传递数据库中的原始image URL，让CreateCourse组件自己处理显示
      this.courseToEdit = {
        id: course.id,
        image: course.originalImage || course.image, // 优先使用原始URL
        course_name: course.course_name,
        teacher_name: course.teacher_name,
        organization: course.organization,
        term: course.term,
        profile: course.profile,
        target: course.target,
        category_id: course.category_id,
        repo_id: course.repo_id,
        code_repo_id: course.code_repo_id
      }

      // 打开创建/编辑课程对话框
      this.createCourseVisible = true
    },

    // 删除课程
    async deleteTeachCourse(course) {
      try {
        await this.$confirm(`您确定要删除课程 ${course.course_name} 吗?`, '删除课程', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          customClass: 'course-confirm-dialog'
        })

        const { value: password } = await this.$prompt('请输入当前管理员登录密码以确认删除', '密码确认', {
          confirmButtonText: '验证并删除',
          cancelButtonText: '取消',
          inputType: 'password',
          inputPlaceholder: '请输入登录密码',
          inputValidator: (value) => {
            if (!value) return '请输入登录密码'
            return true
          }
        })

        const verifyRes = await verifyCurrentPassword({
          password: Encrypt(password)
        })

        if (!(verifyRes && (verifyRes.code === 1 || verifyRes.code === 200))) {
          this.$message.error(verifyRes?.msg || '密码校验失败')
          return
        }

        // 先从前端列表中移除该课程，提升响应速度
        const index = this.teachingCourses.findIndex(item => item.id === course.id)
        if (index !== -1) {
          this.teachingCourses.splice(index, 1)
        }

        deleteCourse(course.id)
          .then(response => {
            if (response && (response.code === 1 || response.code === 200 || response.status === 200)) {
              this.$message({
                type: 'success',
                message: response.msg || `已删除课程: ${course.course_name}`
              })

              // 静默重新加载课程列表，保证数据一致性
              setTimeout(() => {
                this.loadCourses()
              }, 500)
            } else {
              this.$message.error(response?.msg || '删除课程请求失败')
              // 删除失败，恢复列表
              this.loadCourses()
            }
          })
          .catch(error => {
            console.error('删除课程出错:', error)
            this.$message.error('删除课程失败，请稍后重试')
            // 删除失败，恢复列表
            this.loadCourses()
          })
      } catch (error) {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      }
    },

    // 处理课程卡片点击事件
    async handleCourseCardClick(course) {
      if (this.userRole === 'teacher' && this.activeTab === 'teaching') {
        // 教师端“我教的课”跳转到 AMC 命名的新页面
        const courseId = course.id
        if (!courseId) {
          this.$message.error('无法查看课程详情：缺少课程ID')
          return
        }
        this.$router.push(`/teacher-course/${courseId}`)
      } else if (this.userRole === 'student' && this.activeTab === 'learning') {
        console.group('Course click debug')
        console.log('course raw =', course)
        let courseId = course.teach_course_id || course.courseId
        // A: 权威来源 —— 通过 AMC 用户 class_id（优先）或卡片自带 class_id 反查课程ID
        let classId = null
        let uid = null
        let uname = null
        try {
          const token = getTokenInfo && getTokenInfo()
          uid = token && (token.id || token.userId)
          try {
            const info = await getUserInfo()
            const d = info && info.data ? info.data : {}
            uname = d.userName || d.username
          } catch (e) {}
          if (uid) {
            const amc = await getAmcInfoByUserId(uid)
            const arr = amc && amc.data ? amc.data : amc
            let rec = null
            if (Array.isArray(arr)) {
              rec = arr.find(x => String(x.userId || x.id) === String(uid))
              if (!rec && uname) rec = arr.find(x => (x.username || x.userName) && String(x.username || x.userName).toLowerCase() === String(uname).toLowerCase())
              if (!rec) rec = arr.find(x => x.classId || x.gradeId) || arr[0]
            } else if (arr && typeof arr === 'object') {
              rec = arr
            }
            console.log('AMC info: uid=', uid, 'uname=', uname, 'count=', Array.isArray(arr) ? arr.length : (arr ? 1 : 0), 'picked=', rec)
            classId = rec && (rec.classId || rec.gradeId)
            // 如果还是拿不到，直接通过用户名查询 AMC 用户
            if (!classId && uname) {
              try {
                const byName = await amcUserByUsername(uname)
                const u = byName && byName.data ? byName.data : byName
                if (u && (u.classId || u.gradeId)) classId = u.classId || u.gradeId
                console.log('amcUserByUsername picked =', u)
              } catch (e) {}
            }
          }
        } catch (e) {}
        // 若还没有任何班级，则要求输入邀请码加入班级
        if (!classId) {
          let joined = false
          try {
            const r = await this.$prompt('请输入班级邀请码', '加入班级', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              inputPlaceholder: '请输入老师提供的班级邀请码'
            })
            const code = r && r.value ? String(r.value).trim() : ''
            if (!code) {
              this.$message.info('已取消加入班级')
              console.groupEnd()
              return
            }
            const jr = await joinByInviteCode(code)
            const jd = jr && jr.data ? jr.data : {}
            if (!(jr && (jr.code === 1 || jr.code === 20000) && jd.success)) {
              this.$message.error((jr && jr.msg) || '加入班级失败，请检查邀请码')
              console.groupEnd()
              return
            }
            // 如果后端已返回课程ID，则直接按该课程跳转
            if (jd.courseId) {
              console.log('use courseId from invite code mapping:', jd.courseId)
              this.$router.push(`/teacher-course/${jd.courseId}`)
              console.groupEnd()
              return
            }
            joined = true
          } catch (e) {
            this.$message.info('已取消加入班级')
            console.groupEnd()
            return
          }
          if (!joined) {
            console.groupEnd()
            return
          }
          // 加入成功后，再尝试一次读取 AMC 信息以获得最新的 classId
          try {
            if (uid) {
              const amc2 = await getAmcInfoByUserId(uid)
              const arr2 = amc2 && amc2.data ? amc2.data : amc2
              let rec2 = null
              if (Array.isArray(arr2)) {
                rec2 = arr2.find(x => String(x.userId || x.id) === String(uid)) || arr2[0]
              } else if (arr2 && typeof arr2 === 'object') {
                rec2 = arr2
              }
              classId = rec2 && (rec2.classId || rec2.gradeId)
              console.log('AMC info after join, picked =', rec2, 'classId =', classId)
            }
          } catch (e) {}
        }
        if (!classId && course.class_id) classId = course.class_id
        console.log('classId(final from AMC/card) =', classId)
        if (!courseId && classId) {
          try {
            const r = await getClassById(Number(classId))
            const d = r && r.data ? r.data : r
            const mapped = d && (d.courseId || d.course_id)
            if (mapped) {
              courseId = mapped
              console.log('force use courseId from class mapping:', courseId)
              console.groupEnd()
              this.$router.push(`/teacher-course/${courseId}`)
              return
            }
          } catch (e) {}
        }
        // 临时强制规则：classId=3 -> courseId=21（应急用，后续可移除）
        if (!courseId && String(classId) === '3') {
          courseId = 21
          console.log('force rule hit: classId 3 -> courseId 21')
          console.groupEnd()
          this.$router.push(`/teacher-course/${courseId}`)
          return
        }

        // B: 若仍未解析，再尝试匹配授课课程(t_teachcourse.id)，作为次选
        let matchedId = null
        if (!courseId) {
          try {
            const list = await this.fetchTeachCoursesSafely()
            console.log('teachcourse list size =', (list || []).length)
            const exact = (list || []).find(it => {
              const nameEq = (it.course_name || '').trim().toLowerCase() === (course.course_name || '').trim().toLowerCase()
              const teacherEq = (it.teacher_name || '').trim().toLowerCase() === (course.teacher_name || '').trim().toLowerCase()
              return nameEq && teacherEq
            })
            if (exact) matchedId = exact.id
            else {
              const sameName = (list || []).filter(it => (it.course_name || '').trim().toLowerCase() === (course.course_name || '').trim().toLowerCase())
              if (sameName.length === 1) matchedId = sameName[0].id
              else if (sameName.length > 1) matchedId = sameName.sort((a,b) => (b.id || 0) - (a.id || 0))[0].id
            }
          } catch (e) { /* ignore */ }
          if (matchedId) courseId = matchedId
        }
        console.log('courseId after mapping =', courseId)
        // 不再兜底卡片的 course_id，避免错误跳转 19
        if (!courseId) {
          this.$message.error('无法解析到课程ID，请联系老师或稍后重试')
          console.groupEnd()
          return
        }
        console.log('chosen courseId =', courseId)
        console.groupEnd()
        if (!courseId) {
          this.$message.error('无法查看课程详情：缺少课程ID')
          return
        }
        this.$router.push(`/teacher-course/${courseId}`)
      } else {
        // 其他情况保持原有逻辑
        this.viewCourseDetail(course)
      }
    },
    async fetchTeachCoursesSafely() {
      try {
        const res = await getCourseList()
        // 兼容返回格式：纯数组或 {data: []}
        return Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : [])
      } catch (e) {
        return []
      }
    },

    // 查看课程详情
    async viewCourseDetail(course) {
      console.log('=== 开始查看课程详情 ===')
      console.log('点击课程卡片，课程信息:', course)
      console.log('当前用户角色:', this.userRole)
      console.log('当前用户ID:', this.userId)
      console.log('当前activeTab:', this.activeTab)

      console.log('=== 开始查看课程详情 ===')
      console.log('点击课程卡片，课程信息:', course)
      console.log('当前用户角色:', this.userRole)
      console.log('当前用户ID:', this.userId)
      console.log('当前activeTab:', this.activeTab)

      // 教学列表(course对象)用 id；学习列表(选课记录)优先 teach_course_id / courseId，再退回 course_id/id
      const courseId = this.activeTab === 'teaching' ? course.id : (course.teach_course_id || course.courseId || course.course_id || course.id)
      if (!courseId) {
        console.error('课程对象缺少course_id字段:', course)
        this.$message.error('无法查看课程详情：缺少课程ID')
        return
      }

      console.log('跳转到课程详情页面，课程ID:', courseId)
      console.log('目标路由路径:', `/course/detail/${courseId}`)

      // 根据用户角色决定打开方式
      if ((this.userRole === 'teacher' && this.activeTab === 'teaching') || (this.userRole === 'admin' && this.activeTab === 'teaching')) {
        this.$router.push(`/teacher-course/${courseId}`)
        return
      }

      // 其他情况保持原有逻辑
      this.$router.push(`/course/detail/${courseId}`)
    },

    // 进入课程学习
    enterCourseLearning(course) {
      console.log('进入课程学习:', course)
      // 教学列表用 id；学习列表优先 teach_course_id / courseId，再退回 course_id
      const courseId = this.activeTab === 'teaching' ? course.id : (course.teach_course_id || course.courseId || course.course_id || course.id)
      if (!courseId) {
        console.error('课程对象缺少course_id字段:', course)
        this.$message.error('无法进入课程学习：缺少课程ID')
        return
      }

      // 跳转到课程详情页面
      this.$router.push(`/course/detail/${courseId}`)
    },

    // 查看课程资源
    viewCourseResources(course) {
      console.log('查看课程资源:', course)
      // 教学列表用 id；学习列表优先 teach_course_id / courseId，再退回 course_id
      const courseId = this.activeTab === 'teaching' ? course.id : (course.teach_course_id || course.courseId || course.course_id || course.id)
      if (!courseId) {
        console.error('课程对象缺少course_id字段:', course)
        this.$message.error('无法查看课程资源：缺少课程ID')
        return
      }

      // 跳转到课程详情页面
      this.$router.push(`/course/detail/${courseId}`)
    },

    // 加载对应角色的课程数据
    loadInitialCourses() {
      // 根据用户角色加载相应的课程数据
      if (this.userRole === 'teacher') {
        // 教师端，先加载课程类别，再加载课程
        this.activeTab = 'teaching' // 强制设置为教师标签
        this.loadCourseCategories()
      } else if (this.userRole === 'student') {
        // 学生端，加载"我学的课"
        this.activeTab = 'learning' // 强制设置为学生标签
        this.loadLearningCourses()
      } else if (this.userRole === 'admin') {
        // 管理员，加载当前激活标签页的课程
        if (this.activeTab === 'teaching') {
          this.loadCourseCategories()
        } else {
          this.loadLearningCourses()
        }
      }
    }
  },
  async mounted() {
    // 首先获取用户角色与ID
    await this.fetchUserRole()

    // 检查是否有已选课程缓存
    this.checkSelectedCourses()

    // 加载用户AMC信息
    this.loadUserAmcInfo()

    // 如果是学生用户，默认加载可选课程
    if (this.userRole === 'student') {
      this.loadAvailableCourses()
    }
  },

  // 页面激活时刷新AMC信息（从AMC级别选择页面返回时）
  activated() {
    if (this.userId) {
      this.loadUserAmcInfo()
    }
  }
}
</script>

<style scoped>
.course-selection {
  padding: 20px;
  background-color: #f9fafb;
  min-height: 100vh;
}

.course-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.tab-menu {
  display: flex;
  border-bottom: 2px solid #eaeaea;
}

.tab-item {
  padding: 10px 15px;
  margin-right: 20px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
}

.tab-item.active {
  color: #409EFF;
  font-weight: bold;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #409EFF;
}

.search-box {
  width: 250px;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

.course-list {
  margin-top: 20px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.empty-tip {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.course-grid {
  display: flex;
  flex-wrap: wrap;
  min-height: 600px; /* 给予足够的高度，防止布局抖动 */
  width: 100%;
  margin: 0 auto;
}

.course-col {
  margin-bottom: 20px;
  height: 250px; /* 固定高度 */
  padding: 0 10px;
  float: left;
  position: relative; /* 启用定位 */
  width: 25%; /* 确保一行四个 */
  box-sizing: border-box;
}

.course-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s;
  border: 2px solid transparent; /* 统一加上透明边框，防止hover/选中跳动 */
}

.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.teaching-course {
  cursor: default;
  opacity: 0.9;
}

.teaching-course:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: none;
  cursor: pointer;
  transition: transform 0.3s ease, border 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  border: 2px solid transparent; /* 预留边框空间 */
  box-sizing: border-box; /* 确保边框不会改变元素总宽度 */
}

.selected-course {
  border: 2px solid #67C23A;
  box-shadow: 0 5px 15px rgba(103, 194, 58, 0.3);
}

.course-image {
  height: 150px;
  overflow: hidden;
  position: relative;
  margin: -2px -2px 0; /* 负边距抵消边框 */
  padding: 0;
  line-height: 0;
}

.course-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  margin: 0;
  padding: 0;
}

.selected-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #67C23A;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.course-info {
  padding: 15px;
}

.course-title {
  margin: 0 0 10px;
  font-size: 16px;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.course-meta {
  font-size: 13px;
  color: #909399;
  margin-bottom: 5px;
}

.course-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.course-teacher {
  font-size: 13px;
  color: #606266;
}

.course-students {
  font-size: 13px;
  color: #909399;
}

.current-course-info {
  margin-left: 20px;
  font-size: 14px;
  color: #606266;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.course-name {
  color: #409EFF;
  font-weight: bold;
  margin-left: 5px;
}

/* 添加全局样式，确保对话框居中且宽度固定 */
.loading-container {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-top: 20px;
}

.tab-header {
  display: flex;
  align-items: center;
  margin-right: auto;
}

.tab-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #409EFF;
}

.role-loading-container {
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  border-radius: 8px;
  width: 100%;
  margin-top: 20px;
}

/* 课程类别卡片区域样式 */
.category-section {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.category-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.category-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  min-height: 120px;
}

.category-card {
  width: 180px;
  background: #fff;
  border-radius: 8px;
  border: 2px solid #e4e7ed;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
}

.category-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.category-card.selected {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.category-card-image {
  position: relative;
  width: 100%;
  height: 100px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.category-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.category-card-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.category-card-placeholder i {
  font-size: 40px;
  color: rgba(255, 255, 255, 0.8);
}

.category-card-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.3s;
}

.category-card:hover .category-card-actions {
  opacity: 1;
}

.category-card-info {
  padding: 12px;
}

.category-card-name {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-card-desc {
  margin: 0;
  font-size: 12px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-category {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  color: #909399;
}

.empty-category i {
  font-size: 48px;
  margin-bottom: 10px;
}

/* 类别图片上传样式 */
.category-upload-container {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.category-uploader {
  width: 120px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: border-color 0.3s;
}

.category-uploader:hover {
  border-color: #409EFF;
}

.category-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.category-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
</style>

<style>
/* 注意：这里不使用scoped，以便样式能应用到全局弹窗 */
.course-confirm-dialog {
  width: 400px !important;
  margin-top: 15vh !important;
}

.course-confirm-dialog .el-message-box__header {
  padding: 15px 20px;
}

.course-confirm-dialog .el-message-box__content {
  padding: 20px;
}

.course-confirm-dialog .el-message-box__btns {
  padding: 10px 20px 15px;
}

.course-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 5px;
  opacity: 0; /* 默认隐藏 */
  transition: opacity 0.3s ease;
}

.course-card:hover .course-actions {
  opacity: 1; /* 鼠标悬停时显示 */
}

/* 确保按钮在卡片上方 */
.course-actions .el-button {
  z-index: 10;
}

/* 确保el-col响应式布局样式不会覆盖我们的固定布局 */
@media (min-width: 992px) {
  .el-col-lg-6 {
    width: 25% !important;
  }
}

@media (min-width: 768px) {
  .el-col-md-6 {
    width: 25% !important;
  }
}
</style>
